import { Scale, ShieldCheck, GitBranch, Lock, BadgeCheck, FileText } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";

export const CERT_ICONS = { scale: Scale, shield: ShieldCheck, branch: GitBranch, lock: Lock, badge: BadgeCheck, file: FileText };

export const CertificationGrid = () => {
  const { certifications } = useSiteContent();
  return (
    <div className="mt-12 grid gap-4 sm:grid-cols-2" data-testid="certification-grid">
      {certifications.map((c) => {
        const Icon = CERT_ICONS[c.icon] || BadgeCheck;
        return (
          <div key={c.id} data-testid={`compliance-card-${c.id}`} className="flex gap-4 rounded-2xl border border-gray-200 bg-white p-6">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-gray-200 text-oath-ink">
              <Icon className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <div>
              <h3 className="font-display text-lg font-bold text-oath-ink"><span className="text-oath-accent">§ </span>{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-oath-secondary">{c.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CertificationGrid;
